<div class="container-fluid">
  <div class="card-panel mt-5 mb-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-md-8">
          <lib-page-header-light page-title="CONTRATOS" fa-icon="briefcase"></lib-page-header-light>
        </div>
        <div class="col-md-4">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/contratos']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
        </div>
      </div>
      <div class="row">
        <div class="col-9">
          <label class=" mr-2" style="font-weight: bold; color: #009688 ">CONTRATO Nº:</label>
          <label type="text" readonly id="numero_"
            style="font-size: 18px; font-weight: bold; color: #009688 ">{{entidadeForm.get('numero').value}}</label>
        </div>
        <div class="col-3">

        </div>
      </div>
      <hr class="mt-0 mb-4" />
      <div class="row">
        <div class="col-md-8">
          <div class="row">
            <div class="form-group col-md-4">
              <label for="data_inicio">Data Início</label>
              <input value="{{entidadeForm.get('data_inicio').value | date:'dd/MM/yyyy':'GMT'}}" type="text"
                class="form-control-plaintext" id="data_inicio">
            </div>
            <div class="form-group col-md-4">
              <label for="data_termino">Data Término</label>
              <input value="{{entidadeForm.get('data_termino').value | date:'dd/MM/yyyy':'GMT'}}" type="text"
                class="form-control-plaintext" id="data_termino">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-4 pb-0 mb-0">
              <label for="valor_contrato">Valor contrato<span class="text-danger">*</span></label>
              <input unmask="true" [imask]="imaskConfig" formControlName="valor_contrato" type="text"
                class="form-control-plaintext" id="valor_contrato" readonly placeholder="informe o valor"
                style="font-weight: bold; color: #1e88e5">
            </div>
          </div>
          <div class="form-row mb-0 pb-0">
            <div class="form-group col-12 pt-0 mt-0 mb-0 pb-0">
              <label for="favorecido">Favorecido</label>
              <input *ngIf="entidade.favorecido" value="{{entidade.favorecido.cpf_cnpj | CPF}} {{entidade.favorecido.nome}}"
                readonly type="text" class="form-control-plaintext font-weight-bold" id="favorecido">
            </div>
          </div>
          <div class="form-row pt-0 mt-0">
            <div class="form-group col-12 pt-0 mt-0">
              <input *ngIf="entidade.favorecido" value="{{entidade.favorecido.endereco}}" readonly type="text"
                class="form-control-plaintext">
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-3 mb-2" />
      <div class="row">
        <div class="col-md-8">
          <div class="form-row">
            <div class="form-group col-12">
              <label for="ficha">Prazo</label>
              <input *ngIf="entidade.prazo" value="{{entidade.prazo.nome}}" readonly type="text"
                class="form-control-plaintext" id="ficha">
            </div>
          </div>
        </div>

      </div>
      <hr class="mt-3 mb-2" />
      <div class="form-row">
        <div class="form-group col-12">
          <label for="objeto">Objeto</label>
          <textarea formControlName="objeto" readonly class="form-control-plaintext" id="objeto" rows="5"></textarea>
        </div>
      </div>
    </form>
  </div>
</div>
